module.exports = __webpack_public_path__ + "assets/1a75668231e6da9722d69c6466f16058.jpg";